import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { map, switchMap, tap, withLatestFrom } from "rxjs/operators";
import { Plant } from "src/model/class/general classes/plant";
import { PlantsStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { listPlant } from "../selectors/plant.selectors";

/**
 * Handle plant effects
 */
@Injectable()
export class PlantEffects {
  constructor(private _actions$: Actions, private _store: Store) { }
}
